import type { NormalizedDecisionMaker } from '../../shared/types';

import { DecisionMakerCardDesktop } from './components/DecisionMakerCardDesktop';
import { DecisionMakerCardMobile } from './components/DecisionMakerCardMobile';

export const DecisionMakerCard: React.FC<{ dm: NormalizedDecisionMaker }> = ({ dm }) => {
	return (
		<div data-qa="dm-card">
			<DecisionMakerCardDesktop dm={dm} />
			<DecisionMakerCardMobile dm={dm} />
		</div>
	);
};
